// Adds small group headings to the mobile drawer's Shop tab (Shop by style / Collections / By print).
// menu-drawer.js builds the panel from the desktop dropdown's links; this only inserts labels before
// certain links, matched by href, so the links themselves never change. Safe if the panel is missing.
(function () {
  var overlay = document.getElementById('menu-overlay');
  if (!overlay) return;

  var groups = [
    { match: /^\/collections\/all\/?$/, label: 'Shop by style', rule: false },
    { match: /^\/collections\/bagh/, label: 'Collections', rule: true },
    { match: /[?&]pattern=/, label: 'By print', rule: true }
  ];

  function apply() {
    var panel = overlay.querySelector('.menu-drawer__panel');
    if (!panel || panel.getAttribute('data-grouped')) return !!panel;
    var links = panel.querySelectorAll('a.menu-drawer__row');
    var done = {};
    Array.prototype.forEach.call(links, function (a) {
      var href = a.getAttribute('href') || '';
      groups.forEach(function (g, i) {
        if (done[i] || !g.match.test(href)) return;
        done[i] = true;
        var h = document.createElement('p');
        h.className = 'menu-drawer__group' + (g.rule ? ' menu-drawer__group--rule' : '');
        h.textContent = g.label;
        panel.insertBefore(h, a);
      });
    });
    panel.setAttribute('data-grouped', '1');
    return true;
  }

  if (apply()) return;
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(function () { if (apply()) mo.disconnect(); });
  mo.observe(overlay, { childList: true, subtree: true });
})();
